import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const constructDrugData = (data) => {
  const allergiesTableData = data.map((val) => ({
    value: val,
    id: val?.id ?? 0,
    speciality_name: val?.speciality ?? '',
    status: val?.is_active ?? false,
    updated_at: val?.updated_at ?? '',
    created_at: val?.created_at ?? '',
  }));
  return allergiesTableData;
};

export const useSpecialities = create((set, get) => ({
  specialityData: [],
  specialityCount: 0,
  speciality_id: '',
  speciality_name: '',
  loading: false,
  error: {
    speciality_name: '',
  },

  // ------------- STORE METHODS ------------------
  getAllSpecialities: async (search = '', limit = 10, offset = 0) => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['getAllSpecialities', search, offset],
        queryFn: async () => {
          const response = await httpRequest(
            'get',
            `${envConfig.api_url}/backofficeMaster/speciality/get/all?search=${search}&limit=${limit}&offset=${offset}`,
            {},
            true
          );
          return response;
        },
        staleTime: Infinity,
      });
      if (data?.status?.code === 200) {
        set(() => ({
          specialityData:
            Array.isArray(data?.data?.speciality_data) &&
            data?.data?.speciality_data?.length > 0
              ? constructDrugData(data?.data?.speciality_data)
              : [],
          specialityCount: data?.data?.speciality_count,
        }));
      }
      set(() => ({ loading: false }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          '❌ Some thing went wrong plesae try again!'
      );
    }
  },

  specialityStatusUpdate: async (payload) => {
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/speciality/status/update`,
        payload,
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? 'Specialities Status Updated Successfully'
        );
      }
      set({ loading: false });
      return data?.status?.code;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
  addEditSpecialities: async () => {
    const { speciality_name, speciality_id: id } = get();
    const type = id ? 'Update' : 'Add';
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/speciality/upsert`,
        { id: id || '', speciality: speciality_name },
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? `Specialities Data ${type} Successfully`
        );
      }
      set({ loading: false });
      return data;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },

  handleChange: (value) => {
    set({ speciality_name: value });
  },
  isIamValidToSave: () => {
    const { speciality_name, error } = get();
    if (!speciality_name) {
      error.speciality_name = 'Please enter your Specialities name';
    } else {
      error.speciality_name = '';
      return true;
    }
  },

  initialEditSpecialities: (value) => {
    set({
      speciality_name: value.speciality ?? '',
      speciality_id: value.id ?? '',
    });
  },

  clearSpecialitiesData: () => {
    set({
      speciality_name: '',
      speciality_id: '',
    });
  },
}));
